import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle, Heart, ArrowRight, Star, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

const ProfileCompletePage = () => {
  const navigate = useNavigate();
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    // Animate in after mount
    setTimeout(() => setShowContent(true), 100);
  }, []);

  const handleStartSwiping = () => {
    navigate("/matches");
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#1C3A7A] to-[#0f2347] flex items-center justify-center p-4">
      {/* Confetti/sparkle background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className="absolute w-2 h-2 rounded-full animate-pulse"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 50}%`,
              backgroundColor: ['#FAB710', '#22C55E', '#EC4899', '#3B82F6'][i % 4],
              animationDelay: `${i * 0.2}s`,
              opacity: 0.6,
            }}
          />
        ))}
      </div>

      <div 
        className={`max-w-md w-full text-center transition-all duration-700 ${
          showContent ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        {/* Success checkmark */}
        <div className="mb-8 flex justify-center">
          <div className="w-28 h-28 bg-green-500 rounded-full flex items-center justify-center shadow-lg shadow-green-500/30 animate-bounce">
            <CheckCircle className="w-16 h-16 text-white" strokeWidth={2.5} />
          </div>
        </div>

        {/* Title */}
        <h1 className="text-4xl font-bold text-white mb-3">
          You're All Set!
        </h1>
        <p className="text-lg text-indigo-200 mb-8">
          Your profile is complete and you're ready to find meaningful connections
        </p>

        {/* Logo */}
        <div className="mb-8 flex justify-center">
          <div className="w-20 h-20 bg-[#FAB710]/20 rounded-full flex items-center justify-center animate-pulse">
            <img src="/logo192.png" alt="RecoveryMatch" className="w-12 h-12 object-contain" />
          </div>
        </div>

        {/* Tips card */}
        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 mb-8 text-left">
          <h3 className="text-[#FAB710] font-semibold mb-4 flex items-center gap-2">
            <Sparkles className="w-5 h-5" />
            Quick Tips
          </h3>
          
          <div className="space-y-3">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-green-500/20 rounded-full flex items-center justify-center">
                <ArrowRight className="w-5 h-5 text-green-400" />
              </div>
              <span className="text-white/90">Swipe right to like someone</span>
            </div>
            
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-red-500/20 rounded-full flex items-center justify-center">
                <ArrowRight className="w-5 h-5 text-red-400 rotate-180" />
              </div>
              <span className="text-white/90">Swipe left to pass</span>
            </div>
            
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-purple-500/20 rounded-full flex items-center justify-center">
                <Star className="w-5 h-5 text-purple-400" />
              </div>
              <span className="text-white/90">Use Super Like to stand out</span>
            </div>
          </div>
        </div>

        {/* CTA Button */}
        <Button
          onClick={handleStartSwiping}
          className="w-full bg-[#FAB710] hover:bg-[#e5a60f] text-white font-bold py-6 text-lg rounded-full shadow-lg shadow-[#FAB710]/30 flex items-center justify-center gap-2"
          data-testid="start-swiping-btn"
        >
          Start Swiping
          <ArrowRight className="w-6 h-6" />
        </Button>
      </div>
    </div>
  );
};

export default ProfileCompletePage;
